'use client';
import styled from 'styled-components';

export const StyledStatBadge = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  background-color: ${props =>
    props.$hasProgressRing
      ? 'transparent'
      : props.theme.colors.get(props.$backgroundColor)};
`;

export const StatRingSvg = styled.svg`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const StatText = styled.span`
  position: relative;
  z-index: 1;
  ${props => props.theme.fontFamily.newSpirit};
  font-size: 1.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.28px;
  text-align: center;
  color: ${props => props.theme.colors.get(props.$color)};
`;

//* The icon is tinted to `$color` by using it as a mask over a solid fill (mirrors PromoIcon).
export const StatIcon = styled.span`
  display: inline-block;
  flex-shrink: 0;
  width: ${props => props.$iconSize}px;
  height: ${props => props.$iconSize}px;
  background-color: ${props => props.theme.colors.get(props.$color)};
  mask-image: url(${props => props.$src});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
`;
